<div class="wrapper">
    <div class="sidebar" data-color="green">
        <div class="logo">
            <div class="dropdown top-initial">
                <a href="#" class="simple-text text-start" 
                   data-bs-toggle="dropdown"
                   [title]="sidebarTitle">Multitenant
                    <i class="fa-solid fa-caret-down fa-xs ms-2"></i>
                </a>
                <div class="dropdown-menu">
                    <div class="dropdown-header text-dark border-bottom">Admin </div>
                    <div class="divider m-0"></div>
                    <h5 class="dropdown-item" style="cursor:pointer" routerLink="/menu/my-profile">
                        <i class="fa-user fas" aria-hidden="true"></i>&nbsp;
                        <span>My Profile</span>
                    </h5>
                    <h5 class="dropdown-item" style="cursor:pointer" (click)="LogOut()">
                        <i class="fa-solid fa-sign-out-alt" aria-hidden="true"></i>&nbsp;
                        <span>Log Out</span>
                    </h5>
                </div>
            </div>
        </div>
        <div class="sidebar-wrapper">
            <ul class="nav" *ngFor="let menu of Menu">
                <li routerLinkActive="active">
                    <a class="nav-link" routerLink="{{menu.Url}}">
                        <i [class]="menu.Icon"></i>
                        <p>{{menu.Title}}</p>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="main-panel">
        <router-outlet></router-outlet>
    </div>
</div>